// extracted by mini-css-extract-plugin
module.exports = {"table":"table__1K-qb","alignRight":"alignRight__1_JLU","alignLeft":"alignLeft__27AuT","compact":"compact__3ZcH_","gray":"gray__3l66d"};